import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { useAuth } from '../../context/Auth';
import { PersonType } from '../../schemas/facial';

type Props = {
    zIndex: number;
    disabled?: boolean;
    required?: boolean;
    type: 'read' | 'write';
    showTooltip?: boolean;
    tooltipText?: string;
    onTooltipHovered?: (hovered: boolean) => void;
} & ({
    includeEmptyItem: true;
    value: PersonType | '';
    setValue: React.Dispatch<React.SetStateAction<PersonType | ''>>;
} | {
    includeEmptyItem?: false;
    value: PersonType;
    setValue: React.Dispatch<React.SetStateAction<PersonType>>;
});

function PersonTypeDropdown(props: Props) {
    const [items, setItems] = useState<{ label: string; value: string; }[]>([]);
    const { user } = useAuth();

    function getPersonType() {
        try {
            const personTypes: string[] = [];

            if (user?.isAdmin || user?.permissions.facial_module_access) {
                personTypes.push('wanted', 'missing');
            } else {
                if (props.type === 'write') {
                    if (user?.permissions.manage_wanted_person) {
                        personTypes.push('wanted');
                    }

                    if (user?.permissions.manage_missing_person) {
                        personTypes.push('missing');
                    }
                } else if (props.type === 'read') {
                    if (
                        user?.permissions.facial_events_wanted_person ||
                        user?.permissions.facial_alerts_wanted_person
                    ) {
                        personTypes.push('wanted');
                    }

                    if (
                        user?.permissions.facial_events_missing_person ||
                        user?.permissions.facial_alerts_missing_person
                    ) {
                        personTypes.push('missing');
                    }
                }
            }

            const items = personTypes.map((personType) => {
                return {
                    value: personType,
                    label: translate(personType)
                };
            });

            if (props.includeEmptyItem) {
                items.unshift({
                    value: '',
                    label: ''
                });
            }
            setItems(items);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (user) {
            getPersonType();
        }
    }, [user]);

    return (
        <FilterDropdown
            {...props}
            label={translate('type')}
            items={items}
            multiple={false}
            value={props.value ? props.value : null}
        />
    );
}

export default PersonTypeDropdown;
